import React, { useEffect } from 'react';
import '../Styles/Policies.css';

const policies = [
  {
    id: 'terms',
    title: 'Terms & Conditions',
    content: `By using SR Tech Creators' services, you agree to our service guidelines. We provide web and IT services, and the content, code, and designs are our intellectual property unless otherwise contracted.
    This document is an electronic record in terms of Information Technology Act, 2000 and rules
there under as applicable and the amended provisions pertaining to electronic records in various
statutes as amended by the Information Technology Act, 2000. This electronic record is generated
by a computer system and does not require any physical or digital signatures.
This document is published in accordance with the provisions of Rule 3 (1) of the Information
Technology (Intermediaries guidelines) Rules, 2011 that require publishing the rules and
regulations, privacy policy and Terms of Use for access or usage of domain name https://celiri.
com/ ('Website'), including the related mobile site and mobile application (hereinafter referred to
as 'Platform').
The Platform is owned by SR Tech Creators, a company incorporated
under the Companies Act, 1956 with its registered office .Your use of the Platform and services and tools are governed by the following terms and
conditions (“Terms of Use”) as applicable to the Platform including the applicable policies which
are incorporated herein by way of reference. If You transact on the Platform, You shall be subject
to the policies that are applicable to the Platform for such transaction. By mere use of the Platform,
You shall be contracting with the Platform Owner and these terms and conditions including the
policies constitute Your binding obligations, with Platform Owner. These Terms of Use relate to
your use of our website, goods (as applicable) or services (as applicable) (collectively, 'Services').
Any terms and conditions proposed by You which are in addition to or which conflict with these
Terms of Use are expressly rejected by the Platform Owner and shall be of no force or effect.
These Terms of Use can be modified at any time without assigning any reason. It is your
responsibility to periodically review these Terms of Use to stay informed of updates..
For the purpose of these Terms of Use, wherever the context so requires ‘you’, 'your' or ‘user’ shall
mean any natural or legal person who has agreed to become a user/buyer on the Platform..
ACCESSING, BROWSING OR OTHERWISE USING THE PLATFORM INDICATES YOUR
AGREEMENT TO ALL THE TERMS AND CONDITIONS UNDER THESE TERMS OF USE,
SO PLEASE READ THE TERMS OF USE CAREFULLY BEFORE PROCEEDING..
    `
  },
  {
    id: 'refund',
    title: 'Refund Policy',
    content: `Refunds are processed only when requested within 7 days of payment and Refund amount will be credited to the original payment method within 7 days. If the project hasn't started or is incomplete, partial or full refunds may be offered. No refunds after final delivery.`
  },
  {
    id: 'privacy',
    title: 'Privacy Policy',
    content: `We collect basic personal data (name, email, contact) to communicate and deliver services. Your data is never sold or shared. All data is encrypted and securely stored.
    Usage- We use personal data to provide the services you request. To the extent we use your personal data
to market to you, we will provide you the ability to opt-out of such uses. We use your personal data to
assist sellers and business partners in handling and fulfilling orders; enhancing customer experience; to
resolve disputes; troubleshoot problems; inform you about online and offline offers, products, services,
and updates; customise your experience; detect and protect us against error, fraud and other criminal
activity; enforce our terms and conditions; conduct marketing research, analysis and surveys; and as
otherwise described to you at the time of collection of information. You understand that your access to
these products/services may be affected in the event permission is not provided to us.
Sharing- We may share your personal data internally within our group entities, our other corporate
entities, and affiliates to provide you access to the services and products offered by them. These entities
and affiliates may market to you as a result of such sharing unless you explicitly opt-out. We may
disclose personal data to third parties such as sellers, business partners, third party service providers
including logistics partners, prepaid payment instrument issuers, third-party reward programs and other
payment opted by you. These disclosure may be required for us to provide you access to our services and
products offered to you, to comply with our legal obligations, to enforce our user agreement, to facilitate
our marketing and advertising activities, to prevent, detect, mitigate, and investigate fraudulent or illegal
activities related to our services. We may disclose personal and sensitive personal data to government
agencies or other authorised law enforcement agencies if required to do so by law or in the good faith

belief that such disclosure is reasonably necessary to respond to subpoenas, court orders, or other legal
process. We may disclose personal data to law enforcement offices, third party rights owners, or others in
the good faith belief that such disclosure is reasonably necessary to: enforce our Terms of Use or Privacy
Policy; respond to claims that an advertisement, posting or other content violates the rights of a third
party; or protect the rights, property or personal safety of our users or the general public.
Security Precautions- To protect your personal data from unauthorised access or disclosure, loss or
misuse we adopt reasonable security practices and procedures. Once your information is in our
possession or whenever you access your account information, we adhere to our security guidelines to
protect it against unauthorised access and offer the use of a secure server. However, the transmission of
information is not completely secure for reasons beyond our control. By using the Platform, the users
accept the security implications of data transmission over the internet and the World Wide Web which
cannot always be guaranteed as completely secure, and therefore, there would always remain certain
inherent risks regarding use of the Platform. Users are responsible for ensuring the protection of login
and password records for their account.`
  },
  {
    id: 'return',
    title: 'Return Policy',
    content: `We do not offer physical products. Returns are not applicable. Digital service delivery is final and irreversible once approved by the client.`
  }
];

const PoliciesPage = () => {
  useEffect(() => {
    const sections = document.querySelectorAll('.policy-box');
    sections.forEach((el, index) => {
      el.style.animationDelay = `${index * 0.2}s`;
    });
  }, []);

  return (
    <div className="animated-policy-page">
      <header className="animated-policy-header">
        <h1>Our Policies</h1>
        <p>Know your rights and our responsibilities. Transparency matters at SR Tech Creators.</p>
      </header>

      <main className="animated-policy-wrapper">
        {policies.map(policy => (
          <section key={policy.id} id={policy.id} className="policy-box fade-in-up">
            <h2>{policy.title}</h2>
            <p>{policy.content}</p>
          </section>
        ))}
      </main>
    </div>
  );
};

export default PoliciesPage;
